import fetch from "../fetch";
import { setResHeader, expandHeader } from "../axios";
import { getFileSize } from "../utils";

var reqMultipart = "multipart/form-data;charset=UTF-8";
var reqApplication = "application/x-www-form-urlencoded; charset=UTF-8";

export function invokeInit(SC) {
  SC.prototype._init = function (params) {
    params = params || {};
    // 设置头部字段
    var headers = {};
    if (params.headers && JSON.stringify(params.headers) !== "{}") {
      headers = params.headers;
    }
    this.options = params;
    // headers["x-tss-security-token"] = params.securityToken;
    setResHeader(headers);
  };
  SC.prototype.putObject = function (putParams) {
    let { headers, data } = putParams;
    let contentType = headers["Content-Type"];
    var p = Object.assign({}, this.options, putParams);
    var url = `/v3/${data.bucket}/${data.key}`;
    fetch.axiosPut(url, p, contentType);
  };
  // 分片上传
  SC.prototype.multipartUpload = function (putParams) {
    if (!this.paramsFilter(putParams)) {
      return;
    }
    // 获取upload_id
    let { headers, data: paramsData } = putParams;
    let chunkSize = 10 * 1024 * 1024;
    let contentType = headers["Content-Type"];
    let key = paramsData.key.replace(new RegExp("^/"), "");
    let initUploadUrl = `/v3/${paramsData.bucket}/${key}?uploads=1`;
    const options = this.options;
    let newParams = {
      data: paramsData,
      ...options,
      success: function (res) {
        if (res.data && res.data.upload_id) {
          sliceFile(res.data.upload_id);
        } else {
          putParams.fail(res);
        }
      },
      fail: function (newError) {
        putParams.fail(newError);
      },
    };
    expandHeader({
      "Content-Type": contentType || reqApplication,
    });
    fetch.axiosPost(initUploadUrl, newParams, contentType);
    // 分片上传
    function sliceFile(upload_id) {
      fileSlices(function (allChunks) {
        // let fileSize = fetch.getFileSize(nowBolb) // 文件大小
        let isEnd = false;
        let retryTime = 0; // 重试
        let fileSize = getFileSize(paramsData.body);
        let etagArr = [];
        function uploadPart(index) {
          let newChunks = allChunks[index];
          if (allChunks.length === index + 1) {
            isEnd = true;
          }
          let url = `/v3/${paramsData.bucket}/${key}?part_number=${
            index + 1
          }&upload_id=${upload_id}`;
          let newPutParams = {
            data: {
              body: newChunks,
              bucket: paramsData.bucket,
              key: key,
              checkMd5: paramsData.checkMd5,
            },
            ...options,
            success: function (newRes) {
              retryTime = 0;
              if (
                putParams.onprogress &&
                typeof putParams.onprogress === "function"
              ) {
                let loadSize = chunkSize * (index + 1);
                putParams.onprogress({
                  loadedSize: loadSize > fileSize ? fileSize : loadSize,
                  totalSize: fileSize,
                  loaded: Math.floor(((index + 1) / allChunks.length) * 100),
                  total: 100,
                });
              }
              let newObj = {
                etag: newRes.data,
                part_number: index + 1,
              };
              etagArr.push(newObj);
              if (isEnd) {
                completeUpload(upload_id, etagArr);
              } else {
                uploadPart(index + 1);
              }
            },
            fail: function (newPutError) {
              ++retryTime;
              if (retryTime > 5) {
                putParams.fail(newPutError);
              } else {
                uploadPart(index);
              }
            },
          };
          fetch.axiosPut(url, newPutParams, reqMultipart);
        }
        // 首次开始进入
        uploadPart(0);
      });
    }
    // 处理切片文件
    let fileSlices = function (callback) {
      let chunks = [];
      let file = paramsData.body;
      let blobSlice =
        File.prototype.slice ||
        File.prototype.mozSlice ||
        File.prototype.webkitSlice;
      let fileSize = getFileSize(file);
      let chunksNum = Math.ceil(fileSize / chunkSize);
      let currentChunk = 0;
      let frOnload = function (e) {
        chunks[currentChunk] = e.target.result;
        currentChunk++;
        if (currentChunk < chunksNum) {
          loadNextFile();
        } else {
          callback(chunks);
        }
      };
      let frOnerror = function () {
        putParams.fail("read file error");
      };
      function loadNextFile() {
        let fileReader = new FileReader();
        fileReader.onload = frOnload;
        fileReader.onerror = frOnerror;
        let start = currentChunk * chunkSize,
          end = start + chunkSize >= file.size ? file.size : start + chunkSize;
        let blobPacket = blobSlice.call(file, start, end);
        fileReader.readAsArrayBuffer(blobPacket);
      }
      loadNextFile();
    };
    let completeUpload = function (upload_id, etagArr) {
      let completeUrl = `/v3/${paramsData.bucket}/${key}?upload_id=${upload_id}`;
      let completeParams = {
        data: paramsData,
        ...options,
        params: JSON.stringify(etagArr),
        success: function (comRes) {
          putParams.success(comRes);
        },
        fail: function (comErr) {
          putParams.fail(comErr);
        },
      };
      expandHeader({
        "Content-Type": reqMultipart,
      });
      fetch.axiosPost(completeUrl, completeParams, reqMultipart);
    };
  };
  SC.prototype.upload = function (putParams) {
    if (!this.paramsFilter(putParams)) {
      return;
    }
    // 小于5M
    if (getFileSize(putParams.data.body) < 5 * 1024 * 1024) {
      this.putObject(putParams);
    } else {
      this.multipartUpload(putParams);
    }
  };
  SC.prototype.paramsFilter = function (obj) {
    if (!obj || !obj.data || !obj.data.body) {
      throw new Error("data error");
    }
    if (obj.success && typeof obj.success !== "function") {
      throw new Error("success not a function");
    }
    if (obj.fail && typeof obj.fail !== "function") {
      throw new Error("fail not a function");
    }
    return true;
  };
}
